// extracted by mini-css-extract-plugin
export var externalLink = "_b7-0";
export var internalLinkLabel = "_b7-1";